import React, { useState } from "react";
import s from "./style.module.css";
import EditorSection from "../EditorSection";
import CTABox from "../CTABox";
import ResultsBox from "../ResultsBox";

import useAPI from "../../helpers/useAPI";
import {
  input,
  cta,
  output,
  switchText,
  switchTextCTA,
} from "../../content/copy";

const Chart = ({ inputData }) => {
  const [text, setText] = useState("");
  const { response, isLoading } = useAPI(text);

  const updateText = (newText) => {
    if (text === newText) {
      return;
    }

    setText(newText);
  };

  return (
    <div className={s.wrap}>
      <div className={s.input}>
        <div className={s.sticky}>
          <EditorSection
            words={response?.detected_bias || []}
            copy={input}
            setText={updateText}
          />
        </div>
      </div>
      <div className={s.output}>
        <div className={s.sticky}>
          <ResultsBox
            isLoading={isLoading}
            metrics={response?.metrics}
            words={response?.detected_bias}
            copy={output}
          />

          {switchText && (
            <p>
              {switchText}{" "}
              <a
                className={s.link}
                href={
                  process.env.REACT_APP_LANG === "GE-DE"
                    ? window.bwSettings.enURL
                    : window.bwSettings.deURL
                }
              >
                {switchTextCTA}
              </a>
            </p>
          )}
        </div>
      </div>

      {cta && (
        <div className={s.cta}>
          <CTABox {...cta} />
        </div>
      )}
    </div>
  );
};

export default Chart;
